// test1724
(1724 && 0);
